// extracted by mini-css-extract-plugin
export default {"contentText":"ReviewsEmpty_contentText__XO8Ca"};